import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class CurrencyFlagDefault extends Vue {
    @Prop(Boolean)
    selected: boolean;
}
